import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environment';
import { IColor, IColorListResponse, IColorResponse } from './color.model';

export type EntityArrayResponseType = HttpResponse<IColorListResponse>;
export type EntityResponseType = HttpResponse<IColorResponse>;

@Injectable({
  providedIn: 'root'
})
export class ColorService {
  private apiColor = `${environment.wsApiBaseUrl}/api/color`
  protected readonly http = inject(HttpClient);

  findByParams(params: any): Observable<EntityArrayResponseType> {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === null || value === undefined || value === "") delete params[key];
    });
    return this.http.get<IColorListResponse>(`${this.apiColor}`, {observe: 'response', params});
  }

  findById(id: number): Observable<EntityResponseType> {
    return this.http.get<IColorResponse>(`${this.apiColor}/${id}`, {observe: 'response'});
  }

  update(productFormData: FormData, id: number): Observable<HttpResponse<any>> {
    return this.http.put(`${this.apiColor}/${id}`, productFormData, {observe: 'response'});
  }

  activate(activate: boolean, id: number): Observable<EntityResponseType> {
    return this.http.put<IColorResponse>(`${this.apiColor}/activate/${id}`, {active: activate}, {observe: 'response'})
  }
}
